<template>
  <v-main>
    <v-row no-gutters>
      <v-col cols="12">
        <v-sheet
          color="sheet"
          height="150"
        >
          <!--  -->
        </v-sheet>
      </v-col>
      <v-container :class="$vuetify.breakpoint.name == 'lg' ? 'px-16' : ''">
        <v-row no-gutters>
          <v-col
            cols="12"
            style="margin-top: -150px"
          >
            <v-card
              flat
              style="background-color: transparent !important;"
              max-width="80vw"
            >
              <v-card-title class="text-h4">Audit Logs</v-card-title>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            style="margin-top: -48px; position: relative;"
          >
            <v-card
              flat
              outlined
              rounded="lg"
            >
              <v-card-title>
                <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="logs"
                item-key="id"
                :search="search"
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
  </v-main>
</template>

<script>
export default {
  name: 'AuditLogs',
  data: () => ({
    search: '',
  }),
  mounted() {
    this.$store.dispatch('getAuditLogs');
  },
  computed: {
    headers() {
      return this.$store.state.auditLogDataTable.headers;
    },
    logs() {
      return this.$store.state.auditLogData;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
